export enum ConnectionStatus {
  Loading = 0,
  Offline = 1,
  PollingUnstable = 2,
  WebsocketDisconnected = 3,
  WebsocketUnstable = 4,
  SlowCellular = 5,
  Stable = 6,
}
